import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isWorkspaceLoggedIn } from '@/pages/admin-workspace/login/page';
import { setAdminWorkspaceMode } from '@/services';

interface Props {
  children: React.ReactNode;
}

/**
 * 官方工作台路由守卫
 * 未登录 → 跳转 /admin-workspace/login
 * 已登录 → 立即激活工作台模式（同步，非 lazy，确保子组件初始化时能读到正确值）
 */
export default function WorkspaceGuard({ children }: Props) {
  const location = useLocation();

  if (!isWorkspaceLoggedIn()) {
    return <Navigate to="/admin-workspace/login" state={{ from: location }} replace />;
  }

  // 同步激活工作台模式（在渲染阶段立即执行，早于任何子组件初始化）
  setAdminWorkspaceMode(true);

  return <WorkspaceGuardInner>{children}</WorkspaceGuardInner>;
}

function WorkspaceGuardInner({ children }: Props) {
  useEffect(() => {
    // 确保挂载后也是激活状态
    setAdminWorkspaceMode(true);
    return () => {
      // 真正离开工作台路由时才清除
      setAdminWorkspaceMode(false);
    };
  }, []);

  return <>{children}</>;
}
